import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { EMoneyContactSyncSettings } from './EMoneyContactSyncSettings'

export const EMoneySpecificSettings = (): ClickNavigationProps[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <EMoneyContactSyncSettings /> }]
}
